/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Header2 from "ui/kit/typography/Header2";
import Body from "ui/kit/typography/Body";

const ProcessingSection: React.FC = () => {
    return (
        <>
            <Header2>Processing</Header2>
            <Body>Hold tight. We are processing on the backend for this step.</Body>
        </>
    )
}

export default ProcessingSection;